<template>
    <div>
        <div class="uppercase text-gray-700 text-[0.714rem] mb-[0.714rem]">
            {{ category.title }}
        </div>
        <div class="tags flex flex-wrap items-center justify-start">
            <NuxtLink
                v-for="(item,i) in category.items"
                :key="item.key"
                :to="item.to"
                :aria-label="item.aria"
                :title="item.title"
                :id="`${item.id}-${i}`"
                external
                class="cursor-pointer bg-white text-ash-200 px-[0.643rem] mr-2 mb-2 border border-ash-300 rounded-[0.214rem] flex justify-center items-center h-[1.714rem] text-[0.857rem] hover:underline"
            >
                {{ item.title }}
            </NuxtLink>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { NormalizedCategory } from '~~/shared/types/common'

const props = defineProps<{ category: NormalizedCategory }>()
</script>
